import { useEffect, useState } from "react";
import { collection, doc, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

function readDistance(value) {
  const distance = Number(value ?? 0);
  return Number.isFinite(distance) && distance >= 0 ? distance : NaN;
}

// Subscribe only while the current challenge card is mounted. Team progress uses
// the same subscribedUsers totals and teamName filter as the challenge dashboard.
export default function useChallengeProgress(race, userId) {
  const legId = race?.legId;
  const teamName = race?.teamName && race.teamName !== "noTeam" ? race.teamName : null;
  const sourceKey = JSON.stringify([legId, userId, teamName]);
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!legId || !userId) return undefined;
    let active = true;
    const source = teamName
      ? query(collection(db, "races", legId, "subscribedUsers"), where("teamName", "==", teamName))
      : doc(db, "races", legId, "subscribedUsers", userId);
    const unsubscribe = onSnapshot(source, (snapshot) => {
      let distance = 0;
      if (teamName) {
        snapshot.forEach((member) => { distance += readDistance(member.data().totalDistance); });
      } else if (snapshot.exists()) {
        distance = readDistance(snapshot.data().totalDistance);
      }
      if (active) setResult({ sourceKey, status: Number.isFinite(distance) ? "ready" : "error", distance });
    }, () => {
      if (active) setResult({ sourceKey, status: "error" });
    });
    return () => { active = false; unsubscribe(); };
  }, [legId, userId, teamName, sourceKey]);

  if (!legId || !userId) return { status: "error", isTeam: Boolean(teamName) };
  return {
    ...(result?.sourceKey === sourceKey ? result : { status: "loading" }),
    isTeam: Boolean(teamName),
  };
}
